// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__ED-Yt","spin":"loader_spin__8cTbi","loader_container":"loader_loader_container__wcZoo","dot":"loader_dot__naKmn","dotAnimation":"loader_dotAnimation__caEO6"};